const tagTypes = {
  increasedComp: "Increased Compensation",
  multipleOffers: "Multiple Offers",
  firstJob: "First Job via Launch Up",
  dreamTier: "Dream Tier Job Achieved",
  firstInternship: "1st Internship via Launch Up",
  secondInternship: "2nd Internship via Launch Up"
}

export default tagTypes;